import { LifeBuoy } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
import { appendTrackingParams } from '../../utils/utm';

const SUPPORT_URL = 'https://support.evern.ai';

export default function SupportFloat() {
  const { lang } = useLanguage();
  const label = lang === 'es' ? 'soporte' : 'support';
  const href = appendTrackingParams(SUPPORT_URL);

  return (
    <>
      {/* Desktop: vertical pill anchored to the right edge, centered */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid="support-float-desktop"
        className="hidden md:flex fixed right-0 top-1/2 -translate-y-1/2 z-50 group flex-col items-center gap-2 px-2.5 py-4 bg-ev-lime hover:bg-ev-lime-dim text-black rounded-l-2xl shadow-[0_4px_24px_rgba(220,245,123,0.35)] transition-colors">
        <LifeBuoy className="w-4 h-4" strokeWidth={2.2} />
        <span
          className="font-body text-[11px] font-semibold tracking-[0.18em] lowercase"
          style={{ writingMode: 'vertical-rl' }}>
          {label}
        </span>
      </a>

      {/* Mobile: round FAB above the powered-by badge */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid="support-float-mobile"
        className="md:hidden fixed bottom-20 right-4 z-50 flex items-center justify-center w-12 h-12 bg-ev-lime active:bg-ev-lime-dim text-black rounded-full shadow-[0_4px_20px_rgba(220,245,123,0.4)]">
        <LifeBuoy className="w-5 h-5" strokeWidth={2.2} />
      </a>
    </>
  );
}
